import React, { useEffect, useState } from 'react';
import NewModal from './NewModal';
import templatestyle from "./TemplateModal.module.css"
// import manageStyle from "./Managestyles.module.css"
import { InfoOutlineIcon } from "@chakra-ui/icons";
import managestyle from "./manageprojectstyles.module.css"
const ManageProjectStyle = ({ SettingsModal, styleRef, setSettingsModal, setSelectedClientStyles, setShowDescription, searchingStyles, handleCheckChange, setSelectedDescription, selecteddescription, handleStore, filteredStyles, selectedClientStyles, searchStyles, item }) => {
    return (
        <NewModal show={SettingsModal} >
            <div ref={styleRef} className={managestyle.warningcontainer}>
                <div className={managestyle.TemplateHeaderContainer}>
                    <p >Manage Styles</p>
                    <button onClick={() => { setSettingsModal(false); setSelectedClientStyles([]); setShowDescription(false) }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>







                <div className={managestyle.BothSideContainer}>
                    <div className={managestyle.LeftsideContainer}>
                        <div className={managestyle.stylePreviewContainer}>
                            <h1 >Styles*</h1>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "20px",
                            }}
                            >
                                <input
                                    style={{ marginLeft: "20px" }}
                                    type="checkbox"
                                    checked={selectedClientStyles.length === filteredStyles.length && filteredStyles.length > 0}
                                    onChange={() => {
                                        if (selectedClientStyles.length === filteredStyles.length) {
                                            setSelectedClientStyles([]);
                                        } else {
                                            setSelectedClientStyles(filteredStyles.map(([keyName]) => keyName));
                                        }
                                    }}
                                />

                                <div className={managestyle.searchContainer} style={{ flex: 1 }}>


                                    <input type='text' value={searchStyles} onChange={searchingStyles}
                                        className={managestyle.searchinput}
                                    />
                                    <svg className={managestyle.searchicon} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                                        <path d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z"></path>
                                    </svg>
                                </div>
                            </div>

                            <div className={managestyle.stylePreviewBox}>
                                {filteredStyles.length > 0 ?
                                    filteredStyles.map(([keyName, value]) => (
                                        <div
                                            key={keyName}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                gap: "10px",
                                            }}
                                            className={selecteddescription?.name === keyName && managestyle.currentDiscription}
                                        >
                                            <div className={managestyle.individualstyle}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedClientStyles.includes(keyName)}
                                                    onChange={() => handleCheckChange(keyName)}
                                                />

                                                <div onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setSelectedDescription({ name: keyName, value: value });
                                                    setShowDescription(true);

                                                }}

                                                    className={managestyle.individualstyle}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <label className={managestyle.Textcolor}>{keyName}</label>
                                                    <button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setSelectedDescription({ name: keyName, value: value });
                                                            setShowDescription(true);

                                                        }}
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            cursor: "pointer",
                                                            padding: "5px"
                                                        }}
                                                    >
                                                        <InfoOutlineIcon />
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    )) : (
                                        <>
                                            <p>No Styles</p>
                                        </>
                                    )

                                }
                            </div>
                        </div>


                    </div>
                    <div className={managestyle.RightsideContainer}>
                        <div className={managestyle.descriptionViewContainer}>

                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "20px"
                            }}>
                                <h1 className={managestyle.Textcolor}>{selecteddescription?.name}</h1>
                                {/* <button
                                        onClick={() => {
                                            setShowDescription(false);
                                            setSelectedDescription(null);
                                        }}
                                        className={manageStyle.nextbutton}
                                        style={{ width: "auto", padding: "8px 20px" }}
                                    >
                                        Close
                                    </button> */}
                            </div>

                            <div style={{ color: "#222" }}>
                                <h3 className={managestyle.Textcolor}>Description:</h3>
                                <p className={managestyle.Textcolor} style={{ paddingBottom: "10px" }}>{selecteddescription?.value?.description || "No description available"}</p>
                                <p className={managestyle.Textcolor} style={{ paddingBottom: "10px" }}>Before:</p>
                                {selecteddescription?.value?.beforeImage && (
                                    <img
                                        src={process.env.PUBLIC_URL + selecteddescription.value.beforeImage}
                                        alt="After"
                                        style={{ paddingBottom: "10px" }}
                                    />
                                )}

                                <p className={managestyle.Textcolor} style={{ paddingBottom: "10px" }}>After:</p>
                                {selecteddescription?.value?.afterImage && (
                                    <img
                                        src={process.env.PUBLIC_URL + selecteddescription.value.afterImage}
                                        alt="After"
                                        style={{ paddingBottom: "10px" }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>








                <div className={managestyle.nextbtn}>
                    <button className={managestyle.nextbutton} onClick={() => handleStore(item)}>
                        Next
                    </button>
                </div>




            </div>
        </NewModal>
    )
}

export default React.memo(ManageProjectStyle);
